import { render, staticRenderFns } from "./WatchlistManager.vue?vue&type=template&id=04b1b836&"
import script from "./WatchlistManager.vue?vue&type=script&lang=js&"
export * from "./WatchlistManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports